var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticStyle:{"margin":"10px"}},[_c('h3',[_vm._v("Dashboard")])])
}
var staticRenderFns = []

export { render, staticRenderFns }